









import * as bulmaCalendar from 'bulma-calendar';
import { setInterval } from 'timers';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class DatePicker extends Vue {
  @Prop({ required: true, type: Date })
  public minDate!: Date;
  @Prop({ required: true, type: Date })
  public maxDate!: Date;

  public selectedDate: Date | null = null;

  public mounted() {
    const calendars = bulmaCalendar.attach('#date-picker', {
      minDate: new Date(this.minDate),
      maxDate: new Date(this.maxDate),
      startDate: new Date() > this.minDate ? new Date() : this.minDate,
    });

    // This timeout is required due to how the date picker is loaded
    setTimeout(() => {
      calendars[0].on('datepicker:date:selected', (datePicker: any) => {
        this.selectedDate = datePicker.date.toDate();
      });
    }, 100);
  }

  @Watch('selectedDate')
  public onDateChanged(value: string, oldValue: string) {
    this.$emit('input', value);
  }
}
